if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = this.closest('form');
      this.checkoutButton = this.form ? this.form.querySelector('[name="checkout"]') : null;
      
      // Only add the click event to the checkout button
      if (this.checkoutButton) {
        // Use a capture phase listener to intercept clicks before other handlers
        this.checkoutButton.addEventListener('click', this.handleCheckoutClick.bind(this), true);
      }
    }
    
    disconnectedCallback() {
      if (this.checkoutButton) {
        this.checkoutButton.removeEventListener('click', this.handleCheckoutClick, true);
      }
    }
    
    /**
     * Handles checkout button click
     * @param {Event} evt - The event object
     */
    handleCheckoutClick(evt) {
      // Check if terms are accepted
      if (this.cartTermsCheckbox && !this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        evt.stopImmediatePropagation(); // Stop other click handlers from running
        alert((theme && theme.strings && theme.strings.cartTermsConfirmation) ? 
          theme.strings.cartTermsConfirmation : 
          "Please accept the terms and conditions to proceed.");
        return false;
      }
      // If terms are checked, allow the click to proceed normally
    }
  }
  
  customElements.define('cart-terms', CartTerms);
}